/** This room is invitation-only for production QA; matchmaking never allocates it. */
export const QA_ROOM_ID = 'garden-9999999';
export const LAST_MATCH_ROOM = 9999998;
